enum MessageContentPartType {
  Text = "Text",
  Audio = "Audio",
  File = "File",
}
export default MessageContentPartType;
